import { render, staticRenderFns } from "./AddCollectionProtocolEventUnitOfMeasurement.vue?vue&type=template&id=734b5a37&"
import script from "./AddCollectionProtocolEventUnitOfMeasurement.vue?vue&type=script&lang=js&"
export * from "./AddCollectionProtocolEventUnitOfMeasurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VForm,VTextField,VTextarea})
